function isTrue(value: string | null): boolean {
  return value?.trim().toLowerCase() === 'true';
}

const DESIGN_DATA_BUNDLES = new Set(['caddata', 'modeldata', 'scannerdata', 'scenefiles']);

function isDesignDataFilter(filter: Element, bundleName: string): boolean {
  const expression = filter.getAttribute('regex')?.toLowerCase() ?? '';
  const isConstructionInfo =
    bundleName.toLowerCase() === 'projectdata' && expression.includes('constructioninfo');

  return (
    isTrue(filter.getAttribute('relevantForOrdering')) ||
    isConstructionInfo ||
    (DESIGN_DATA_BUNDLES.has(bundleName.toLowerCase()) &&
      isTrue(filter.getAttribute('relevantForProjectStatus')))
  );
}

/** Parses the Portal's XML file-filter rules for order-relevant design data. */
export function parseOrderFileFilters(xml: string): readonly RegExp[] {
  const document = new DOMParser().parseFromString(xml, 'application/xml');
  if (document.querySelector('parsererror')) {
    throw new Error('Invalid file-filter configuration.');
  }

  const rules: RegExp[] = [];
  for (const bundle of Array.from(document.getElementsByTagName('FilterBundle'))) {
    const bundleName = bundle.getAttribute('name')?.trim() ?? '';
    for (const filter of Array.from(bundle.getElementsByTagName('Filter'))) {
      if (!isDesignDataFilter(filter, bundleName)) {
        continue;
      }

      const expression = filter.getAttribute('regex')?.trim();
      if (!expression) {
        continue;
      }

      try {
        rules.push(new RegExp(expression, isTrue(filter.getAttribute('ignoreCase')) ? 'i' : undefined));
      } catch {
        throw new Error('Invalid file-filter rule.');
      }
    }
  }

  if (rules.length === 0) {
    throw new Error('The file-filter configuration contains no order-upload rules.');
  }

  return rules;
}

/** Keeps only files accepted by at least one server-managed order-upload rule. */
export function selectDesignFiles(files: readonly File[], rules: readonly RegExp[]): File[] {
  const selected: File[] = [];

  for (const file of files) {
    const matches = rules.some((rule) => {
      rule.lastIndex = 0;
      return rule.test(file.name);
    });

    if (matches && !selected.includes(file)) {
      selected.push(file);
    }
  }

  return selected;
}
